import * as l from "react";
const c = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "BZ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#BZ_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#0168B4"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "BZ_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#BZ_svg__b)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v3h32V0H0zM0 21v3h32v-3H0z",
      fill: "#E93C43"
    }
  ), /* @__PURE__ */ l.createElement("path", { d: "M16 18a6 6 0 110-12 6 6 0 010 12z", fill: "#F7FCFF" }), /* @__PURE__ */ l.createElement("path", { d: "M16 20a8 8 0 110-16 8 8 0 010 16z", fill: "#fff" }), /* @__PURE__ */ l.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M16 19a7 7 0 100-14 7 7 0 000 14z",
      stroke: "#9C4C17",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.573 4.083l-.155.335c.256.139.353.454.353.644s-.1.333-.353.465l.155.347c.106-.056.211-.102.31-.147.356-.158.638-.283.638-.665 0-.466-.427-.697-.889-.947l-.059-.032zm2.242.21l-.241.279c.207.204.214.534.161.717-.052.181-.188.292-.467.35l.054.375c.117-.024.23-.04.338-.055.385-.054.691-.097.796-.463.129-.449-.218-.789-.593-1.156l-.048-.047zm1.793 1.03l.313-.196.032.058c.251.461.484.888.23 1.28-.208.32-.513.27-.897.21a5.352 5.352 0 00-.34-.047l.058-.375c.284.027.447-.039.55-.197.104-.16.194-.477.055-.733zm2.084 1.193l-.355.102c.063.285-.11.565-.255.69-.142.123-.317.142-.582.038l-.16.344c.112.044.216.093.314.139.352.164.632.295.92.045.352-.306.246-.78.132-1.293l-.014-.065zm.94 1.83H23l-.004.067c-.031.524-.06 1.009-.483 1.206-.346.161-.579-.042-.872-.297a5.33 5.33 0 00-.264-.22l.248-.287c.227.174.4.204.571.124.173-.08.417-.301.435-.592zm1.12 2.138l-.353-.107c-.102.273-.4.413-.59.44-.186.025-.343-.054-.509-.286l-.321.202c.07.097.13.195.188.287.206.33.37.592.747.539.462-.065.631-.52.814-1.012l.024-.063zm-.199 2.047l.31.2-.04.055c-.311.422-.6.813-1.062.748-.378-.053-.463-.35-.57-.724-.03-.104-.06-.215-.101-.327l.364-.106c.096.27.225.388.412.415.188.026.514-.026.687-.26zm-.216 2.406l-.238-.283c-.235.174-.56.129-.734.048-.17-.08-.259-.231-.272-.517l-.38-.005c.006.12.004.234.002.343-.007.389-.013.698.333.859.423.197.813-.093 1.235-.405l.054-.04zm-1.275 1.613l.15.337-.062.023c-.491.185-.947.355-1.298.05-.288-.25-.198-.546-.084-.918.032-.104.066-.214.093-.33l.363.11c-.066.278-.023.448.12.572.143.125.445.258.718.156zm-1.476 1.892l-.052-.365c-.29.022-.543-.189-.647-.349-.103-.158-.097-.333.043-.582l-.319-.206c-.059.105-.121.2-.18.292-.213.326-.38.585-.173.905.254.39.739.352 1.262.31l.067-.005zm-1.952.682l-.057.365-.065-.014c-.513-.113-.988-.218-1.116-.666-.105-.367.131-.565.43-.815.083-.07.171-.144.258-.226l.244.29c-.207.197-.263.363-.211.544.052.183.233.46.517.522zm-2.268.793l.155-.335c-.256-.139-.353-.454-.353-.645 0-.188.1-.332.353-.464l-.155-.346c-.106.055-.21.102-.31.146-.356.157-.638.283-.638.665 0 .466.428.697.89.947l.058.032zm-1.998-.489l-.242.28-.048-.048c-.375-.367-.722-.707-.593-1.156.105-.367.41-.41.796-.463.108-.015.221-.03.339-.055l.053.376c-.28.057-.415.168-.467.35-.053.182-.046.512.162.716zm-2.35-.554l.313-.196c-.14-.256-.05-.573.055-.733.102-.158.265-.224.549-.197l.058-.375c-.119-.012-.232-.03-.34-.047-.384-.06-.689-.11-.896.21-.255.392-.022.819.23 1.28l.031.058zm-1.416-1.491l-.354.102-.015-.065c-.114-.512-.22-.987.132-1.293.288-.25.568-.12.92.045.099.046.203.095.314.139l-.16.344c-.265-.104-.44-.085-.582.038-.144.125-.318.405-.255.69zm-1.664-1.728h.37c.017-.291.261-.513.434-.593.171-.08.344-.05.57.123l.249-.287a5.308 5.308 0 01-.263-.219c-.294-.255-.527-.458-.873-.297-.422.197-.451.682-.483 1.206l-.004.067zm-.396-2.032l-.353-.107.024-.063c.183-.491.352-.947.814-1.012.378-.053.542.209.747.54.058.091.119.189.188.286l-.32.202c-.167-.232-.324-.311-.51-.285-.19.026-.487.166-.59.44zm-.464-2.354l.31.2c.174-.234.499-.286.688-.26.186.027.315.146.41.415l.365-.106a5.327 5.327 0 01-.101-.327c-.107-.374-.192-.671-.57-.724-.462-.065-.75.326-1.062.748l-.04.054zm.764-1.922l-.237-.283.053-.04c.422-.312.812-.602 1.235-.405.346.161.34.47.333.86-.002.108-.004.223.001.342l-.379-.006c-.013-.285-.101-.436-.272-.516-.173-.08-.5-.126-.734.048zm.885-2.234l.15.337c.274-.102.575.031.719.156.142.124.185.294.119.572l.363.11c.028-.116.062-.226.093-.33.114-.372.205-.667-.083-.918-.352-.306-.807-.135-1.299.05l-.062.023zm1.68-1.19l-.052-.365.066-.005c.524-.042 1.008-.08 1.262.31.208.32.04.579-.173.905-.059.091-.121.187-.18.292l-.319-.206c.14-.249.146-.424.043-.582-.104-.16-.357-.371-.647-.349zm1.957-1.412l-.057.365c.285.063.465.339.517.522.052.181-.004.347-.211.544l.245.29c.086-.082.174-.156.257-.226.299-.25.535-.448.43-.815-.128-.448-.603-.553-1.116-.666a40.48 40.48 0 01-.065-.014z",
      fill: "#5B8C39"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.28 13.987s-1.1-.024-1.1.481c0 .506 0 1.065.55.786.55-.28 1.222-.39 1.577-.196a4.876 4.876 0 002.353.592c1.168 0 1.09-.396 2.166-.396 1.075 0 2.996-.086 2.551-.436-.445-.35-.968-.571-1.368-.571-.4 0-.706 0-1.546-.412-.84-.412-1.779-.45-2.724-.316-.946.133-1.07.468-1.63.468h-.83z",
      fill: "#247805"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M16.1 15.65l.071.24h.003l.006-.003.02-.006.072-.025a3.89 3.89 0 00.992-.537c.545-.41 1.113-1.091 1.113-2.127V10.73v0V10.72v0-.002 0-.004 0-.002 0-.002 0-.002 0-.002 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0h-.25.25v-.25h-4.553v.25h.25-.25V13.191c0 1.01.57 1.69 1.111 2.105a4.09 4.09 0 001.06.581l.02.007.006.002h.002v.001h0l.078-.238zm0 0l.071.24-.074.022-.073-.024.076-.238z",
      fill: "#fff",
      stroke: "#565656",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "BZ_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 13,
      y: 10,
      width: 6,
      height: 7
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M16.1 15.65l.071.24h.003l.006-.003.02-.006.072-.025a3.89 3.89 0 00.992-.537c.545-.41 1.113-1.091 1.113-2.127V10.73v0V10.72v0-.002 0-.004 0-.002 0-.002 0-.002 0-.002 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0h-.25.25v-.25h-4.553v.25h.25-.25V13.191c0 1.01.57 1.69 1.111 2.105a4.09 4.09 0 001.06.581l.02.007.006.002h.002v.001h0l.078-.238zm0 0l.071.24-.074.022-.073-.024.076-.238z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 0.5
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#BZ_svg__c)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      opacity: 0.4,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.197 13.91l1.934-1.425 2.032 1.586v2.257h-3.966V13.91z",
      fill: "#84CEFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.258 14.413h3.592v.5h-3.592v-.5z",
      fill: "#006AC9"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.443 14.907h3.316v.265h-3.316v-.265z",
      fill: "#59C800"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.443 15.237h3.316v.5h-3.316v-.5z",
      fill: "#FFD800"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.727 14.51l-2.59-1.977v-2.67h2.59v4.648z",
      fill: "#F7D85D"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.549 13.423s.082.425.144.425c.063 0 .176-.425.176-.425s.014.425.077.425.055-.356.156-.425c.036-.025.082.423.138.425.047.002.162-.425.162-.425s.035.425.089.425c.054 0 .163-.425.163-.425v1.072H15.55v-1.072z",
      fill: "#F5F6F6"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.101 14.84c.56 0 1.013-.095 1.013-.213s-.453-.214-1.013-.214c-.56 0-1.013.096-1.013.214s.454.214 1.013.214z",
      fill: "#892E2E"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.29 11.104l.207-.163 1.401 1.44-.208.162-1.4-1.439z",
      fill: "#A46031"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.516 12.768l-.221-.149 1.362-1.63.222.147-1.363 1.632z",
      fill: "#892E2E"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M16.408 11.319l.208-.13 1.401 1.143-.208.13-1.4-1.143z",
      fill: "#A46031"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M16.7 12.486l-.259-.176 1.333-1.075.284.234-1.357 1.017z",
      fill: "#F5F6F6"
    }
  )), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.566 16.534l.65.204v.561h-.65v-.765zM14.102 15.387l.365.204v.56h-.365v-.764zM17.541 16.534l-.65.204v.561h.65v-.765zM18.006 15.387l-.366.204v.56h.366v-.764z",
      fill: "#69F"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M13.748 16.576c-.12 0-.218.002-.332.008-.274.013-.292.013-.367-.018a.626.626 0 01-.157-.103c-.155-.127-.322-.42-.503-.879v-.02c.224-.483.685-.543 1.37-.184.18.094.706.38.701.378.24.128.407.21.572.276.342.138.665.2 1.078.2.248 0 .536-.07.871-.204.194-.077.395-.17.641-.295.033-.017.548-.284.675-.346.223-.107.37-.159.47-.159a16.947 16.947 0 00.293 0c.494.006.737.088.737.345 0 .243-.158.573-.473.991l-.015.01c-.623.083-.985.083-1.096-.005-.03-.025-.113-.014-.266.035-.069.022-.44.155-.554.193-.477.158-.885.243-1.3.243-.634 0-1.328-.246-2.08-.737.136.174.05.27-.265.27z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.416 16.584c.114-.006.213-.008.332-.008.314 0 .4-.097.264-.27.753.49 1.447.736 2.08.736.416 0 .825-.085 1.301-.243l.3-.104.254-.089c.153-.049.236-.06.266-.035.111.088.473.088 1.096.004l.015-.009c.315-.418.473-.748.473-.99 0-.258-.243-.34-.737-.346a9.779 9.779 0 00-.292 0c-.102 0-.248.052-.471.16-.1.048-.444.225-.599.305l-.076.04a7.655 7.655 0 01-.641.296c-.335.133-.623.203-.871.203-.413 0-.736-.062-1.078-.2a5.725 5.725 0 01-.572-.276c.005.002-.521-.284-.702-.378-.684-.36-1.145-.3-1.369.185v.02c.181.458.348.75.503.878.066.054.111.084.157.102.075.032.093.032.367.019zm-.35-.063a.59.59 0 01-.145-.095c-.146-.12-.308-.404-.486-.85.213-.446.643-.5 1.302-.154.18.095.706.38.702.378.24.13.41.212.576.279.348.14.676.203 1.095.203.255 0 .547-.072.888-.207.195-.077.398-.172.645-.297l.077-.04c.156-.08.497-.257.597-.305.216-.104.359-.155.45-.155a16.997 16.997 0 00.293 0c.467.005.69.081.69.297 0 .229-.151.547-.456.954-.602.081-.956.08-1.052.004-.049-.039-.139-.027-.309.028l-.256.09-.298.103c-.473.156-.877.24-1.287.24-.7 0-1.477-.305-2.33-.918l-.028.04c.39.292.39.412.014.412a6.7 6.7 0 00-.334.008c-.265.013-.282.013-.348-.015z",
      fill: "#666"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M13.028 15.808l-.067-.066c.152-.163.352-.204.594-.124.094.031.707.385.87.468.598.304 1.167.473 1.772.473.869 0 1.708-.274 2.516-.821.305-.248.496-.248.496.037h-.093c0-.17-.09-.17-.349.04-.825.56-1.683.84-2.57.84-.621 0-1.203-.174-1.813-.483-.171-.087-.774-.435-.857-.463-.21-.07-.373-.036-.499.1z",
      fill: "#565757"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.492 6.943l-.181.001c.004.743-.162 1.212-.486 1.413a3.654 3.654 0 01-.092.056 10.76 10.76 0 00-.122-.308l-.016-.04c-.192-.472-.235-.69-.136-.749l-.098-.14c-.218.13-.17.369.064.948l.017.04c.058.143.101.252.132.339l-.019.01-.029.017a.711.711 0 00-.327-.072c-.575 0-.974-.151-1.206-.45l-.147.097c.27.347.724.519 1.353.519.052 0 .1.006.145.018-.091.079-.104.16-.104.442 0 .176.038.41.114.703-.058-.075-.113-.111-.169-.111v.166a.066.066 0 01-.015-.002h-.001l-.001-.001.002.001h-.001a.15.15 0 01.022.022c.025.03.056.077.092.142.073.135.164.34.27.614l.056-.018.005.013.03-.01v.005h.057l.001.046.181-.003v-.052l.032.004a6.94 6.94 0 00.064-.736.73.73 0 01.281-.384c.309-.2.49-.391.54-.581l-.176-.039c-.037.142-.192.306-.468.484a.777.777 0 00-.182.163c-.017-.273-.067-.494-.15-.661v-.05a.758.758 0 00-.036-.222l.139-.082c.386-.24.57-.76.565-1.552zm-.978 1.789c.05.041.093.094.13.16v1.246c-.149-.47-.223-.822-.223-1.054 0-.26.008-.293.068-.337a.38.38 0 01.025-.015z",
      fill: "#984800"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.984 7.085c-.103.03-.23.044-.365.035a1.485 1.485 0 01.311.059.288.288 0 01.054-.094zm.228-.134a.212.212 0 00.047-.101c.032-.204-.262-.42-.657-.482-.395-.063-.74.052-.773.255a.21.21 0 00.011.106c-.146-.106-.384-.177-.654-.182-.45-.008-.817.172-.821.4-.004.23.357.422.806.43.45.008.818-.172.822-.4a.22.22 0 00-.01-.07c.119.092.297.166.502.199.037.005.073.01.108.012-.408-.025-.747.13-.786.374-.043.271.303.552.771.626.397.063.755-.042.882-.24.052.024.106.046.163.066.473.163.928.084 1.018-.176.09-.26-.22-.603-.693-.766-.274-.094-.541-.107-.736-.051zm-2.938.032c.1.18-.102.484-.452.678-.35.193-.714.204-.814.024-.1-.18.102-.484.452-.678.35-.194.714-.204.814-.024zm1.093 1.135c-.004.252-.453.449-1.003.439-.549-.01-.99-.222-.987-.474.005-.252.454-.449 1.003-.44.55.01.992.223.987.475zm-.633 1.763c.496-.06.875-.294.847-.522-.027-.227-.452-.363-.948-.302-.496.061-.875.295-.847.523.028.227.452.362.948.301zm1.83.304c.437.101.838-.016.895-.262.057-.246-.252-.527-.69-.628-.438-.101-.84.016-.896.262-.057.245.252.527.69.628zm.387-.933c.662.129 1.238.032 1.286-.215.048-.248-.45-.553-1.112-.681-.662-.129-1.238-.033-1.286.215-.048.247.45.552 1.112.681z",
      fill: "#247805"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.245 10.94s-.313 2.97-.313 3.372c0 .403.575 0 .575 0s.085-1.418.281-1.945c.196-.527.289.052.289.36v1.746s.716.098.716-.16c0-.26-.298-3.373-.298-3.373h-1.25z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.206 10.898l-.004.037c-.21 1.983-.313 3.106-.313 3.377 0 .318.238.318.646.034l.016-.012.002-.02c.056-.942.149-1.587.278-1.934.077-.208.1-.218.135-.132.04.101.068.306.068.478v1.783l.038.005c.502.069.767.01.767-.202 0-.111-.052-.723-.14-1.681l-.01-.106-.102-1.099-.034-.356-.01-.1-.003-.035-.003-.037h-1.331zm.26 3.392c-.349.24-.49.237-.49.022 0-.264.104-1.376.31-3.33h1.17l.009.096.034.356.102 1.099.01.105c.087.952.14 1.567.14 1.674 0 .13-.202.179-.63.125v-1.71a1.59 1.59 0 00-.073-.508c-.075-.185-.201-.133-.3.134-.132.354-.226.999-.282 1.937z",
      fill: "#979797"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.207 9.918s.246.885.354.885c.11 0 .77-.543.77-.543v.736h1.23v-.326l.158.326.215-.1.372-.439h-.372s-.108-.704-.108-.816c0-.11.004-.331-.265-.411-.27-.08-.401-.221-.401-.221s.58-.83.138-.83c-.442 0-.641.106-.641.106v.609c0 .115-.634-.022-.634.336 0 .358-.295.688-.295.688l-.075-.24-.446.24z",
      fill: "#FF863B"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.068 8.383c.243 0 .44-.097.44-.216 0-.12-.197-.217-.44-.217-.244 0-.441.097-.441.217s.197.216.44.216z",
      fill: "#000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M10.847 10.26l-.199-.165c.383-.414.81-.716 1.279-.903.444-.178 1.024-.46 1.74-.85l.13.218c-.723.393-1.312.68-1.768.863-.43.172-.824.45-1.182.838z",
      fill: "#740000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.658 8.433l.167.785.741-.392-.583-.65-.325.257z",
      fill: "#F9FCFF",
      stroke: "#6C6C6C",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.86 11.307s.31 3.1.31 3.52c0 .42-.571 0-.571 0s-.084-1.48-.279-2.03c-.194-.55-.286.054-.286.375v1.823s-.71.102-.71-.168.295-3.52.295-3.52H19.86z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.898 11.263l.004.039c.207 2.07.31 3.242.31 3.524 0 .333-.236.333-.64.035l-.016-.012-.002-.02c-.055-.983-.148-1.657-.275-2.019-.078-.217-.1-.227-.135-.137-.04.105-.067.319-.067.498v1.861l-.037.006c-.499.071-.761.01-.761-.212 0-.115.051-.754.138-1.755l.01-.11.102-1.146.033-.372.01-.104.003-.037.003-.04h1.32zm-.258 3.54c.345.25.485.247.485.023 0-.276-.102-1.437-.306-3.476h-1.161l-.01.1-.033.372c-.034.386-.07.776-.101 1.147l-.01.11a52.294 52.294 0 00-.138 1.747c0 .135.2.186.623.13v-1.785c0-.19.028-.413.073-.53.075-.193.2-.139.298.14.13.37.224 1.042.28 2.022z",
      fill: "#979797"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.91 10.178s-.244.923-.352.923c-.107 0-.762-.567-.762-.567v.77h-1.22v-.341l-.157.34-.213-.105-.37-.457h.37s.107-.736.107-.852c0-.116-.005-.346.262-.43.267-.083.398-.23.398-.23s-.575-.867-.137-.867c.438 0 .636.111.636.111v.635c0 .12.628-.022.628.351 0 .374.293.719.293.719l.075-.25.442.25z",
      fill: "#824028"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.065 8.576c-.241 0-.437-.101-.437-.226s.196-.226.437-.226.437.101.437.226-.196.226-.437.226z",
      fill: "#000"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M21.526 10.345l-2.673-1.393s-.05-.468-.565-.609c-.517-.14-.928-.359-.928-.359l-.235.36s-.419-.111 1.163.608c1.581.72-.06-.39.39 0l2.848 1.393z",
      fill: "#BA611F"
    }
  )))
);
export {
  c as default
};
